import React from "react";

const cardata = [
  {
    title: "Refer UPI",
    link: "refer-upi",
    description: "Refer UPI Earn Upto 150/-",
  },
  {
    title: "Credit Card",
    link: "credit_card",
    description: "Refer Credit Card Earn Upto 9600/-",
  },
  {
    title: "Bank Account Opening",
    link: "bank_account_opening",
    description: "Refer Zero Balance Bank Account Opening Earn upto 2000/-",
  },
  {
    title: "Small Loan",
    link: "Small_loan",
    description: "Refer Loan Earn Upto 1000/-",
  },
  {
    title: "Demat Account Opening",
    link: "Demat_account",
    description: "Refer Loan Earn Upto 1200/-",
  },
  {
    title: "Personal Loan",
    link: "Personal_loan",
    description: "Refer Personal Loan Earn Upto 24600/-",
  },
];

const Home = () => {
  return (
    <div className={` px-4 mx-auto max-w-screen-xl lg:px-6`}>
      <div className="px-4 py-2 ">
        

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 mt-4 ">
          {cardata.map((card, index) => (
            <a className="bg-[#c4a984f1] hover:bg-[#c4a984]/60 rounded-md p-5" key={index} href={card.link}>
              <div className="">
                <h2 className="">
                  <p className="text-xl lg:text-2xl font-semibold ">{card.title}</p>
                </h2>
                <h6 className="">
                  <a href={card.link} className="text-lg lg:text-xl tracking-tight ">
                    {card.description}
                  </a>{" "}
                </h6>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
